import type { NodeSn } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { findNodeIdByNodeSn } from './helpers/findNodeIdByNodeSn';

export interface UnhighlightGraphNodeCommand {
  nodeSn: NodeSn;
}

export const unhighlightGraphNode: GraphCommandFactory<
  UnhighlightGraphNodeCommand
> = (cmdContext) => (command) => {
  const nodeId = findNodeIdByNodeSn(
    cmdContext.getState().graph,
    command.nodeSn,
  );
  cmdContext.updateState((draft) => {
    if (nodeId === null) {
      return;
    }
    cmdContext.eventEmitter.emit('nodeHighlight', { nodeId: null });
    draft.highlightedNodeId = null;
  });
};
